(function () {
  var ajustes = window.tbAjustes || {};
  var dos = function (n) { return String(n).padStart(2, '0'); };

  function partesHasta(objetivo) {
    var t = Math.max(0, Math.floor((objetivo - Date.now()) / 1000));
    var d = Math.floor(t / 86400); t -= d * 86400;
    var h = Math.floor(t / 3600); t -= h * 3600;
    var m = Math.floor(t / 60);
    var s = t - m * 60;
    return { d: d, h: h, m: m, s: s };
  }

  function rellenar(plantilla, p) {
    return plantilla
      .replace(/\[dd\]/g, dos(p.d))
      .replace(/\[d\]/g, p.d)
      .replace(/\[h\]/g, dos(p.h))
      .replace(/\[m\]/g, dos(p.m))
      .replace(/\[s\]/g, dos(p.s));
  }

  function fechaDe(el) {
    var valor = el.getAttribute('data-tb-objetivo') || ajustes.fechaFin;
    var f = new Date(valor).getTime();
    return isNaN(f) ? 0 : f;
  }

  function actualizarCuentas() {
    document.querySelectorAll('[data-tb-cuenta]').forEach(function (el) {
      var p = partesHasta(fechaDe(el));
      el.querySelectorAll('[data-tb-parte]').forEach(function (n) {
        var k = n.getAttribute('data-tb-parte');
        n.textContent = dos(p[k]);
      });
      if (el.hasAttribute('data-tb-plantilla')) {
        el.textContent = rellenar(el.getAttribute('data-tb-plantilla'), p);
      }
    });
    document.querySelectorAll('[data-tb-progreso]').forEach(function (el) {
      var inicio = new Date(el.getAttribute('data-tb-inicio') || ajustes.fechaInicio).getTime();
      var fin = fechaDe(el);
      var pct = fin > inicio ? Math.round(((Date.now() - inicio) / (fin - inicio)) * 100) : 100;
      el.style.width = Math.max(4, Math.min(100, pct)) + '%';
    });
  }

  actualizarCuentas();
  setInterval(actualizarCuentas, 1000);

  var abierto = null;
  var ultimoFoco = null;
  var velo = document.querySelector('[data-tb-velo]');

  function abrirCajon(cajon) {
    if (!cajon) return;
    if (abierto && abierto !== cajon) cerrarCajon(true);
    ultimoFoco = document.activeElement;
    abierto = cajon;
    cajon.classList.add('tb-abierto');
    cajon.setAttribute('aria-hidden', 'false');
    if (velo) velo.classList.add('tb-abierto');
    document.body.classList.add('tb-bloqueado');
    var cerrar = cajon.querySelector('[data-tb-cerrar]');
    if (cerrar) setTimeout(function () { cerrar.focus(); }, 60);
  }

  function cerrarCajon(sinFoco) {
    if (!abierto) return;
    abierto.classList.remove('tb-abierto');
    abierto.setAttribute('aria-hidden', 'true');
    abierto = null;
    if (velo) velo.classList.remove('tb-abierto');
    document.body.classList.remove('tb-bloqueado');
    if (!sinFoco && ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  window.tbCajones = { abrir: abrirCajon, cerrar: cerrarCajon };

  document.addEventListener('click', function (e) {
    var abrir = e.target.closest('[data-tb-abrir]');
    if (abrir) {
      var destino = document.getElementById(abrir.getAttribute('data-tb-abrir'));
      if (destino) {
        e.preventDefault();
        if (destino.id === 'tb-carrito' && window.tbCarrito) window.tbCarrito.refrescar();
        abrirCajon(destino);
      }
      return;
    }
    if (e.target.closest('[data-tb-cerrar]') || e.target.closest('[data-tb-velo]')) {
      e.preventDefault();
      cerrarCajon();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrarCajon();
    if (e.key === 'Tab' && abierto) {
      var foco = abierto.querySelectorAll('a[href], button:not([disabled]), input, textarea, select');
      if (!foco.length) return;
      var primero = foco[0];
      var ultimo = foco[foco.length - 1];
      if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
    }
  });

  document.querySelectorAll('[data-tb-videos]').forEach(function (marco) {
    marco.addEventListener('touchstart', function () { marco.classList.add('tb-pausado'); }, { passive: true });
    marco.addEventListener('focusin', function () { marco.classList.add('tb-pausado'); });
    marco.addEventListener('click', function (e) {
      var boton = e.target.closest('[data-tb-play]');
      if (!boton) {
        marco.classList.toggle('tb-pausado');
        return;
      }
      var tarjeta = boton.closest('.tb-video');
      var video = tarjeta && tarjeta.querySelector('video');
      if (!video) return;
      marco.classList.add('tb-pausado');
      marco.querySelectorAll('video').forEach(function (v) {
        if (v !== video) { v.pause(); v.closest('.tb-video').classList.remove('tb-reproduciendo'); }
      });
      video.controls = true;
      video.play();
      tarjeta.classList.add('tb-reproduciendo');
    });
  });
})();

(function () {
  document.querySelectorAll('[data-tb-comparador]').forEach(function (marco) {
    var control = marco.querySelector('[data-tb-comparador-control]');
    var fijar = function () {
      marco.classList.add('tb-manual');
      marco.style.setProperty('--tb-corte', control.value + '%');
    };
    control.addEventListener('input', fijar);
    control.addEventListener('pointerdown', fijar);
  });

  document.querySelectorAll('[data-tb-abrir-resena]').forEach(function (boton) {
    var campos = document.getElementById(boton.getAttribute('aria-controls'));
    if (!campos) return;
    boton.addEventListener('click', function () {
      var abrir = campos.hidden;
      campos.hidden = !abrir;
      boton.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      if (abrir) {
        var primero = campos.querySelector('input:not([type="hidden"]), textarea');
        if (primero) primero.focus();
      }
    });
  });

  document.querySelectorAll('[data-tb-mas-resenas]').forEach(function (boton) {
    boton.addEventListener('click', function () {
      var seccion = boton.closest('section');
      seccion.querySelectorAll('[data-tb-resena-oculta]').forEach(function (r) { r.hidden = false; });
      boton.hidden = true;
    });
  });

  var formularioContacto = document.getElementById('tb-formulario-contacto');
  if (formularioContacto) {
    formularioContacto.addEventListener('submit', function (e) {
      var casilla = formularioContacto.querySelector('[data-tb-privacidad]');
      if (casilla && !casilla.checked) {
        e.preventDefault();
        casilla.focus();
        casilla.closest('.tb-casilla').classList.add('tb-error');
      }
    });
  }
})();

(function () {
  document.querySelectorAll('[data-tb-pestanas]').forEach(function (grupo) {
    var pestanas = Array.prototype.slice.call(grupo.querySelectorAll('[role="tab"]'));
    var activar = function (p, foco) {
      pestanas.forEach(function (o) {
        var sel = o === p;
        o.classList.toggle('tb-activa', sel);
        o.setAttribute('aria-selected', sel ? 'true' : 'false');
        o.tabIndex = sel ? 0 : -1;
        var panel = document.getElementById(o.getAttribute('aria-controls'));
        if (panel) panel.hidden = !sel;
      });
      if (foco) p.focus();
    };
    pestanas.forEach(function (p, i) {
      p.addEventListener('click', function () { activar(p); });
      p.addEventListener('keydown', function (e) {
        var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
        if (n === null) return;
        e.preventDefault();
        activar(pestanas[(n + pestanas.length) % pestanas.length], true);
      });
    });
    var ancla = window.location.hash.replace('#', '');
    if (ancla) {
      var elegida = pestanas.filter(function (p) { return p.textContent.trim().toLowerCase().replace(/\s+/g, '-') === decodeURIComponent(ancla).toLowerCase(); })[0];
      if (elegida) activar(elegida);
    }
  });
})();
